import '@forest/native-diagnostics'

import { initializeNativeBridge } from '@forest/native-services'
import { language } from './lib/params'
import { defineCustomClientStrategy } from './paraglide/runtime'

defineCustomClientStrategy('custom-queryParam', {
  getLocale: () => language,
  setLocale: () => {},
})

initializeNativeBridge({
  bifrost: { enableDebug: import.meta.env.MODE !== 'production' },
})
